/**
 * local-date.ts — daty w czasie lokalnym użytkownika (zegar i strefa jego przeglądarki):
 * 1) dzisiejsza data jako `YYYY-MM-DD` (lokalne pola daty, NIE `toISOString()`, które daje datę
 *    w UTC — tuż po północy 1. dnia miesiąca w Polsce UTC wskazuje jeszcze poprzedni dzień),
 * 2) konwersja wartości inputu `datetime-local` (czas lokalny bez strefy) ⇄ ISO 8601 ze strefą.
 *
 * Konsumenci: wysyłka faktury do Symfonii (`clientDate` — serwer używa jej jako „dziś"),
 * `WidgetConfigModal` (daty z godziną w konfiguracji widgetu) oraz wspólna logika kontrolki
 * wartości `lib/list-actions/value-control.ts` („Zmień zbiorczo" i edytor zapisanej akcji).
 */

/**
 * Wartość inputu `datetime-local` (`YYYY-MM-DDTHH:mm`, czas LOKALNY bez strefy) → ISO 8601 UTC.
 * Naiwny string baza zinterpretowałaby w strefie sesji i godzina by się przesunęła — strefę
 * przeglądarki doklejamy tu. Zwraca null dla pustej lub niepoprawnej wartości.
 */
export function localDateTimeInputToIso(local: string): string | null {
  if (!local) return null;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/**
 * Odwrotność `localDateTimeInputToIso`: ISO (z dowolną strefą) → wartość inputu `datetime-local`
 * w czasie lokalnym przeglądarki. Pusta lub niepoprawna wartość → pusty string.
 */
export function isoToLocalDateTimeInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${localIsoDate(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function localIsoDate(date: Date = new Date()): string {
  const y = String(date.getFullYear()).padStart(4, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
